export const HOME = '/';
export const SERVICES = '/services';
export const ABOUTUS = '/aboutus';
export const GAMEDEV= "/game-development";
export const THANKYOU = '/thankyou';
export const DEFAULT = '*';
export const CONTACTUS = '/contact_us';
export const POJECT_PAGE = '/project';
export const BLOCKCHAIN = '/blockchain_development';
export const GAME = '/game_development';
export const PROGRESSIVE = '/progressive-web-app-services';
export const MACHINELEARNING = '/machine-learning-services';
export const GENERATIVEAI = '/generative-ai';
export const CLOUDMANAGE = '/cloud-managed-services';
export const CLOUD = '/cloud-consulting';
export const OUTSOURCE = '/it-outsourcing-services';
export const AUTOMATION = '/automation-services';
export const VISION = '/vision-services';
export const BUSINESS = '/business-services';
export const ANALYTICS = '/data-analytics-services';
export const DEVOPS = '/configuration-management-services';
export const INTEGRATION = '/configuration-integration-service';
export const DEPLOYMENT = '/configuration-deployment-service';
export const CONTAINERIZATION = '/containerization-services';
export const COMPUTING = '/cloud-computing-services';
export const SCALABILITY = '/scalability-services';
export const ORCHES = '/orchestration-services';
export const SECURITY = '/security-services';
export const HEALTHCARE = '/healthcare-services';
export const MONITOR = '/monitoring-observability-services';
export const PRODUCT = '/product-development-services';
export const NFTMARKETPLACE = '/nft-marketplace-services';
export const MOBILE = '/mobile_app_development';
export const WEBDEVELOPEMENT = '/web_development';
export const APPDEVELOPMENT = '/mobile_app_development';
// export const METAVERSEDEVELOPMENT = '/metaverse_development';
export const METAVERSE = '/metaverse-development-services';
export const DAPP = '/decentralized-development-services';

export const OURWORK = '/our_work';
export const OURPARTNERS = '/our_partners';
export const TERMSANDCONDITIONS = '/termsandcondition';
export const PRIVACYANDPOLICY = '/privacyandpolicy';
export const REFUNDPOLICY = '/refund-policy';
export const ETHEREUM = '/ethereum';
export const CRYPTOCURRENCY = '/crypto_currency';
// export const NFTMARKETPLACE = '/nft_marketplace';
export const NFT = '/nfts';
export const EXCHANGECRYPTO = '/exchangecrypto';
export const CAREERS = '/careers';
export const JOBDESCRIPTION = '/jobdescription';
export const APPLICATION = '/application';
export const SWIPER = '/swiper';
export const ALLJOBS = '/all_jobs'
export const CASE_STUDY = '/case-study/:company'
export const TEAM = '/team'
export const BLOGMAINPAGE = '/blog-page';
export const BLOGDETAIL = '/blog-page/:slug';
export const WEBDEV = '/website-development'
export const UIUX = '/ui-ux-service'
// export const MOBILEAPPDEVELOPMENT = '/app-development';
export const MOBILEAPPDEVELOPMENT = '/mobile-app-development-services';
export const ARVRDEV = '/ar-vr-development'
export const ARVRDevelopmentServices  = '/ar-vr-development-services'
export const CRMDEVELOPMENT = '/crm-development'